import Icon from "./IconBase.js";
const SearchWIcon = (props) => {
  return (
    <Icon width="18" height="18" viewBox="0 0 20 20" {...props}>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="8.80553"
          cy="8.80589"
          r="7.49047"
          stroke="#fff"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.0153 14.4043L16.9519 17.3334"
          stroke="#fff"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  );
};
export default SearchWIcon;
